<template>
  <div class="main-wrapper">
    <navbarseven></navbarseven>

    <indexsevenhome />

    <indexsevenrestaurant />

    <indexsevenlatest />

    <indexsevenpricing />

    <indexsevenblog />

    <indexsevenfooter />

    <scroll />
    
  </div>
</template>
